import React from 'react';
import { RefinedCruiseLoadingSkeleton } from '../../CruiseCard/RefinedCruiseCard/RefinedCruiseLoadingSkeleton'
import { FAKE_RESULTS_COUNT } from '../constants';

function ResultsLoading() {
    return (
      <>
        {
          [...Array(FAKE_RESULTS_COUNT)].map((_item, i) => {
            const fakeResultKey = `refined-fake-result-${i}`;
            return <RefinedCruiseLoadingSkeleton key={fakeResultKey}/>;
          })
        }
      </>
    );
}

export default ResultsLoading;
